import { useState } from "react";

const styles = {
  divContainer: {
    fontFamily: '"Century Gothic", sans-serif',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  divHeader: {
    textAlign: "center",
    fontWeight: "bold",
    padding: "10px"
  },
  divBody: {
    width: "100%",
    border: "2px solid black",
    boxSizing: 'border-box',
  },
  divProfile: {
    display: "flex",
    height: "300px",
  },
  divPicDetails: {
    display: "flex",
    width: "35%",
    height: "100%",
  },
  divImage: {
    width: "50%",
    padding: "5px",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  divValues: {
    width: "50%",
    padding: "5px",
    height: "100%",
    display: 'flex',
    alignItems: 'center',
  },
  divInfo: {
    display: "flex",
    border: "1px solid black",
    fontSize: "14px",
    fontWeight: "bolder",
    padding: "0px 2px 0px 2px",
    minWidth: "20%",
    flex: '0 0 auto',
  },
  divInfo1: {
    border: "1px solid black",
    fontSize: "14px",
    fontWeight: "bolder",
    padding: "4px 8px",
    width: "35%",
    boxSizing: 'border-box',
    backgroundColor: "#c0e4f5",
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  divInfoValues1: {
    border: "1px solid black",
    fontSize: "14px",
    padding: "4px 8px",
    width: "65%",
    boxSizing: 'border-box',
    backgroundColor: "#c0e4f5",
    display: 'table-cell',
    verticalAlign: 'middle',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    whiteSpace: 'normal',
  },
  divNextTab: {
    fontSize: "16px",
    margin: "2px",
    padding: "10px 0px 3px 13px",
    color: "#1d6dba",
    backgroundColor: "white",
    fontWeight: "bold",
  },
  divNextQuestion: {
    fontSize: "14px",
    padding: "15px 10px",
    border: "1px solid black",
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  divOtherInfo: {
    display: "flex",
    backgroundColor: "#c0e4f5",
    justifyContent: "flex-end",
    border: "1px black solid",
    fontSize: "14px",
    flexWrap: 'wrap',
    marginTop: "2px",
  },
  divOtherDetails: {
    width: "40%",
    minWidth: "150px",
    border: "1px black solid",
    textAlign: "right",
    padding: "4px 8px",
    boxSizing: 'border-box',
    flex: '0 0 40%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  divOtherDetailValues: {
    width: "60%",
    border: "1px black solid",
    padding: "4px 8px",
    boxSizing: 'border-box',
    flex: '1 1 60%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  divOtherTableInfoValues: {
    display: "flex",
    border: "1px black solid",
    fontSize: "14px",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 5px",
    width: "50%",
    flex: '1 1 50%',
    boxSizing: 'border-box',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    textAlign: 'center',
  },
  divOtherTableInfo: {
    display: "flex",
    border: "1px black solid",
    fontSize: "14px",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bolder",
    width: "50%",
    flex: '1 1 50%',
    padding: "10px 5px",
    boxSizing: 'border-box',
    textAlign: 'center',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  divNextAnswer: {
    fontSize: "14px",
    backgroundColor: "#c0e4f5",
    padding: "20px",
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    lineHeight: '1.4',
  },
  span: {
    padding: "0px 3px 0px 3px",
  },
  imageStyle: {
    width: '180px',
    height: '180px',
    objectFit: 'cover',
  },
  divInfoValues: {
    display: "flex",
    border: "1px solid black",
    fontSize: "14px",
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  divOtherInfoValues: {
    display: "flex",
    border: "1px solid black",
    fontSize: "14px",
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  imagevalueStyle: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    imageRendering: "-webkit-optimize-contrast"
  },
  divProfileDetails: {
    width: "65%",
    height: "100%",
    display: 'flex',
    flexDirection: 'column',
  },
  divOtherDetailsone: {
    width: "100%",
    backgroundColor: "#c0e4f5",
    border: "1px black solid",
    fontSize: "14px",
    boxSizing: 'border-box',
  },
  bulletList: {
    margin: '0',
    paddingLeft: '15px',
    fontSize: '14px',
    lineHeight: '1.3',
  },
  bulletItem: {
    marginBottom: '2px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  }
};

export default function App({ data = {} }) {
  const currentYear = new Date().getFullYear();

  const getArrayAsString = (array, mapper) => {
    if (!Array.isArray(array) || array.length === 0) return '';
    return array.map(mapper).filter(Boolean).join(', ');
  };


  const [imageUrl] = useState(
    "/ttec_values.jpg"
  );

  return (
    <div style={styles.divContainer}>
      <h5 style={styles.divHeader}>CFO GTO {currentYear} Career Cards</h5>
      <div style={styles.divBody}>
        <div style={styles.divProfile}>
          <div style={styles.divPicDetails}>
            <div style={styles.divImage}>
              {data.image ? (
                <img src={data.image} alt="Employee" style={styles.imageStyle} />
              ) : (
                <div style={{
                  fontSize: '10px',
                  textAlign: 'center',
                  border: '1px dashed #ccc',
                  width: '120px',
                  height: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  Employee Photo
                </div>
              )}
            </div>
            <div style={styles.divValues}>
              <img src={imageUrl} alt="TTECValues" style={styles.imagevalueStyle} />
            </div>
          </div>
          <div style={styles.divProfileDetails}>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Name:</div>
              <div style={styles.divInfoValues1}><b>{data.name || 'N/A'}</b></div>
            </div>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Job Level:</div>
              <div style={styles.divInfoValues1}>{data.jobLevel || 'N/A'}</div>
            </div>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Job Title:</div>
              <div style={styles.divInfoValues1}>{data.jobTitle || 'N/A'}</div>
            </div>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Time at TTEC:</div>
              <div style={styles.divInfoValues1}>{data.timeAtTTEC || 'N/A'}</div>
            </div>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Time in Current Role:</div>
              <div style={styles.divInfoValues1}>{data.time_in_current_role || 'N/A'}</div>
            </div>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Education/Degree:</div>
              <div style={styles.divInfoValues1}>{data.education_degree || 'N/A'}</div>
            </div>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Certification(s):</div>
              <div style={styles.divInfoValues1}>{(data.certificates || 'N/A')}</div>
            </div>
            <div style={{ display: "table", width: "100%", height: "12.5%" }}>
              <div style={styles.divInfo1}>Languages:</div>
              <div style={styles.divInfoValues1}>
                {getArrayAsString(data.emp_languages, (l) => l.language_dropdown?.language || l.language)}
              </div>
            </div>
          </div>
        </div>

        <div style={styles.divNextTab}>Internal Mobility</div>
        <div style={styles.divOtherInfo}>
          <div style={styles.divOtherDetailsone}>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherDetails}>Current Location:</div>
              <div style={styles.divOtherDetailValues}>{data.location_desc || 'Not specified'}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherDetails}>Willingness to Relocate:</div>
              <div style={styles.divOtherDetailValues}>{data.willingness_to_relocate || 'Not specified'}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherDetails}>Location Preferences:</div>
              <div style={styles.divOtherDetailValues}>
                {getArrayAsString(data.EmpLocationPreferences, (loc) => loc.location_dropdown?.location || loc.location)}
              </div>
            </div>
          </div>
        </div>

        <div style={styles.divNextTab}>Role Readiness</div>
        <div style={styles.divOtherInfo}>
          <div style={styles.divOtherDetailsone}>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherDetails}>Your next role preference:</div>
              <div style={styles.divOtherDetailValues}>{data.next_role_preference || 'Not specified'}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherDetails}>Timing for next role:</div>
              <div style={styles.divOtherDetailValues}>{data.timing_for_next_role || 'Not specified'}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherDetails}>Future Career Aspirations:</div>
              <div style={styles.divOtherDetailValues}>{data.future_career_aspirations || 'Not specified'}</div>
            </div>
          </div>
        </div>

        <div style={styles.divNextTab}>Experience (TTEC and External)</div>
        <div style={styles.divOtherInfo}>
          <div style={styles.divOtherDetailsone}>
            {
              data.work_experiences
                ?.filter(exp => exp.company_name === "TTEC")
                .sort((a, b) => {
                  // Sort by start date descending (most recent first)
                  const dateA = new Date(a.starting_date || '1900-01-01');
                  const dateB = new Date(b.starting_date || '1900-01-01');
                  return dateB.getTime() - dateA.getTime();
                })
                .slice(0, 2)
                .map((exp, index) => {
                  return (
                    <div style={{ display: "flex" }} key={index}>
                      <div style={styles.divOtherDetails}>Previous Position:</div>
                      <div style={styles.divOtherDetailValues}>
                        {exp.previous_position_role}, {exp.company_name} : {exp.short_description || 'No description provided'}
                      </div>
                    </div>
                  );
                })
            }
            {
              data.work_experiences
                ?.filter(exp => exp.company_name !== "TTEC")
                .sort((a, b) => {
                  // Sort by start date descending (most recent first)
                  const dateA = new Date(a.starting_date || '1900-01-01');
                  const dateB = new Date(b.starting_date || '1900-01-01');
                  return dateB.getTime() - dateA.getTime();
                })
                .slice(0, 2)
                .map((exp, index) => {
                  return (
                    <div style={{ display: "flex" }} key={index}>
                      <div style={styles.divOtherDetails}>Previous Position:</div>
                      <div style={styles.divOtherDetailValues}>
                        {exp.previous_position_role}, {exp.company_name} : {exp.short_description || 'No description provided'}
                      </div>
                    </div>
                  );
                })
            }
          </div>
        </div>

        <div style={styles.divNextTab}>Additional TTEC Leadership Roles (or Involvement)</div>
        <div style={styles.divOtherInfo}>
          <div style={styles.divOtherDetailsone}>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherTableInfo}>ERGs</div>
              <div style={styles.divOtherTableInfo}>TTEC Communities</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherTableInfoValues}>
                {getArrayAsString(data.EmpResourceGroup, (rg) => rg.resource_group_dropdown?.resource_group)}
              </div>
              <div style={styles.divOtherTableInfoValues}>
                {getArrayAsString(data.EmpTtecCommunities, (tc) => tc.ttec_communities)}
              </div>
            </div>
          </div>
        </div>

        <div style={styles.divNextTab}>Leadership Culture (Executive Competencies)</div>
        <div style={styles.divOtherInfo}>
          <div style={styles.divOtherDetailsone}>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherTableInfo}>Strengths Displayed (choose at least 2)</div>
              <div style={styles.divOtherTableInfo}>Areas for Development (choose at least 2)</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={styles.divOtherTableInfoValues}>
                {getArrayAsString(
                  data.EmpLeadershipCulture?.filter(lc => lc.flag === 'STRENGTH'),
                  (lc) => lc.leadership_culture_dropdown_sd?.name
                )}
              </div>
              <div style={styles.divOtherTableInfoValues}>
                {getArrayAsString(
                  data.EmpLeadershipCulture?.filter(lc => lc.flag === 'DEVELOPMENT'),
                  (lc) => lc.leadership_culture_dropdown_sd?.name
                )}
              </div>
            </div>
          </div>
        </div>

        <div style={styles.divNextTab}>Performance Summary</div>
        <div style={styles.divNextQuestion}>
          <b>What were your top accomplishments for the previous performance year (personal development or business deliverable)?</b> </div>
        <div style={styles.divNextAnswer}>
          {data.last_year_top_achievement || 'Not specified'}
        </div>
        <div style={styles.divNextQuestion}>
          <b>What would you have liked to have done better during the previous performance year (personal development or business deliverable)?Provide an example where you didn't achieve the result you were hoping for. How did you overcome it/ what did you learn from the experience?</b> </div>
        <div style={styles.divNextAnswer}>
          {data.last_year_personal_development_review || 'Not specified'}
        </div>
        <div style={styles.divNextQuestion}>
          <b>If you had a redo for a prior business deliverable, what would it be?</b>
        </div>
        <div style={styles.divNextAnswer}>
          {data.redo_for_previous_business_year || 'Not specified'}
        </div>
        <div style={styles.divNextQuestion}>
          <b>What are your goals or focus areas for the next two quarters? What areas of development are you focused on and your major milestones ahead of you?</b>
        </div>
        <div style={styles.divNextAnswer}>
          {data.goal_next_two_quarters || 'Not specified'}
        </div>

      </div>
    </div>
  );
}